export default {
  from: 'From',
  perLesson: '/lesson',
}
